import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/close_ic.png';
const _withScopeId = n => (_pushScopeId("data-v-7b7c9766"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modal-content" };
const _hoisted_2 = { class: "flex-align-center modelTitle" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
export default /*#__PURE__*/ _defineComponent({
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        titleText: {
            type: String,
            default: ''
        }
    },
    emits: ['closeModel'],
    setup(__props, { emit }) {
        const props = __props;
        const closeModal = () => {
            emit('closeModel');
        };
        /* const showModal = ref<boolean>(false) */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["modal", { 'is-active': __props.showModal }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("a", { onClick: closeModal }, _hoisted_4),
                            _createElementVNode("p", null, _toDisplayString(__props.titleText), 1)
                        ]),
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ], 2)
            ]));
        };
    }
});
